export default "__VITE_ASSET__nG2CpUyX__"